module.exports = __webpack_public_path__ + "img/calendar-blue.7e183b5e.svg";